export const GET_PEOPLE_TO_VISIT = 'GET_PEOPLE_TO_VISIT';
export const CRUD_PEOPLE_TO_VISIT = 'CRUD_PEOPLE_TO_VISIT';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const CLEAN_PEOPLE_TO_VISIT_STATE = 'CLEAN_PEOPLE_TO_VISIT_STATE';
export const CLEAN_PEOPLE_TO_VISIT_ERROR = 'CLEAN_PEOPLE_TO_VISIT_ERROR';
export const CHANGE_SETTING_LOCAL = 'CHANGE_SETTING_LOCAL';
export const SET_PEOPLE_TO_VISIT_DATA = 'SET_PEOPLE_TO_VISIT_DATA';
export const SET_FETECHING = 'SET_FETECHING';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_AMOUNT_OF_PEOPLE_TO_VISIT = 'SET_AMOUNT_OF_PEOPLE_TO_VISIT';